import { RateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';
import type { WrapPromiseFunctionType } from '@uppy/utils/lib/RateLimitedQueue';

type QueueOptions = Parameters<RateLimitedQueue['wrapPromiseFunction']>[1];

/**
 * `@uppy/tus` schedules local chunk uploads with `run()`, while Companion uploads (Google Drive, Box,
 * Dropbox, Url) go through `wrapPromiseFunction()` and hold their slot until Companion reports success.
 * Companion only starts pulling a file once its socket gets a slot, so sharing one pool makes remote
 * files wait behind each other (and behind local uploads). Remote uploads get their own pool here.
 */
export class RemoteAwareQueue extends RateLimitedQueue {
  private readonly remoteQueue: RateLimitedQueue;

  constructor(localLimit: number, remoteLimit: number) {
    super(localLimit);
    this.remoteQueue = new RateLimitedQueue(remoteLimit);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  wrapPromiseFunction<T extends (...args: any[]) => any>(
    fn: T,
    queueOptions?: QueueOptions,
  ): WrapPromiseFunctionType<T> {
    return this.remoteQueue.wrapPromiseFunction(fn, queueOptions);
  }
}
